import React from 'react';

import { LoadingArea, LoadingAreaProps, LoadingImage, LoadingPhrase } from './styles';
import useLoadingPhrases from '../../hooks/useLoadingPhrases';

import LogoLoading from '../../img/svg/LogoLoading.svg';

interface LoadingProps extends LoadingAreaProps {
  /** Tag do curso atual, usada para exibir frases específicas (com fallback global). */
  courseTag?: string | null;
  /** Habilita a exibição de frases educativas durante o loading. Default: true. */
  showPhrases?: boolean;
}

export default function Loading({ height, courseTag, showPhrases = true }: LoadingProps) {
  const { phrase, index, hasPhrases } = useLoadingPhrases({
    courseTag,
    enabled: showPhrases,
  });

  return (
    <LoadingArea height={height}>
      <LoadingImage url={LogoLoading}>
        <div></div>
      </LoadingImage>
      <LoadingPhrase key={hasPhrases ? index : 'fallback'} aria-live="polite" aria-atomic="true">
        {hasPhrases ? phrase : 'Carregando...'}
      </LoadingPhrase>
    </LoadingArea>
  );
}
